var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTheme } from '@material-ui/core';
import { SmartCheckConfirmTemplate } from './SmartCheckConfirmTemplate';
import { SmartCheckCountDownTemplate } from './SmartCheckCountDownTemplate';
import { SmartCheckBeforeUseTemplate } from './SmartCheckBeforeUseTemplate';
import { makeStyles } from '@material-ui/core/styles';
import { SmartCheckAfterUsedTemplate } from './SmartCheckAfterUsedTemplate';
export var useSmartCheckCommonStyles = makeStyles(function (theme) { return ({
    section: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    centerSection: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        textAlign: 'center',
    },
    image: {
        width: '100%',
        height: '100%',
    },
    smartCheckUsedAt: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    smartCheckUsedAtBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    smartCheckOrganizationName: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    smartCheckOrganizationNameBigShopNameTemplate: {
        display: 'block',
        fontSize: '50px',
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    smartCheckOrganizationNameSuffix: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    smartCheckOrganizationNameSuffixBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDown: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownAfter: {
        color: 'red',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    countDownAfterBigShopNameTemplate: {
        textAlign: 'center',
        fontWeight: 'bold',
    },
}); });
/**
 * SmartCheck用テンプレート
 */
export var SmartCheckTemplate = function (props) {
    var theme = useTheme();
    if (props.confirm) {
        // 確認画面へ
        return React.createElement(SmartCheckConfirmTemplate, __assign({}, props, { theme: theme }));
    }
    else if (props.available.status === 'USED') {
        if (props.smartCheckCountDown.countDownComplete) {
            // カウントダウン終了後
            return React.createElement(SmartCheckAfterUsedTemplate, __assign({}, props, { theme: theme }));
        }
        else {
            // カウントダウン中またはカウントダウン設定無し
            return React.createElement(SmartCheckCountDownTemplate, __assign({}, props, { theme: theme }));
        }
    }
    else {
        // 使用前画面
        return React.createElement(SmartCheckBeforeUseTemplate, __assign({}, props, { theme: theme }));
    }
};
//# sourceMappingURL=SmartCheckTemplate.js.map